import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface ServiceProviderState {
  data: [] | null | any;
  totalPage: number | null;
  currentPage: number | null;
  totalRecords: number | null;
}

const initialState: ServiceProviderState = {
  data: null,
  totalPage: null,
  currentPage: null,
  totalRecords: null,
};

export const serviceProviderSlice = createSlice({
  name: 'serviceProvider',
  initialState,
  reducers: {
    setServiceProvider: (state, action) => {
      state.data = action.payload.data;
      state.totalPage = action.payload.totalPage;
      state.currentPage = action.payload.currentPage;
      state.totalRecords = action.payload.totalRecords;
    },
    addNewServiceProvider: (state: any, action) => {
      state.data = [action.payload.data, ...state.data];
    },
    reset: (state) => {
      state = initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setServiceProvider, addNewServiceProvider, reset } = serviceProviderSlice.actions;
export const getServiceProviderDetails = (state: RootState) => state.serviceProvider.data;
export const getServiceProviderTotalRecords = (state: RootState) => state.serviceProvider.totalRecords;
// export const getInActiveServiceProviderSpaces = (state: RootState) => {
//   return state.serviceProvider.data && state.serviceProvider.data.filter((parking: any) => parking.currentStatus === 'Pending');
// };

export default serviceProviderSlice.reducer;
